export default {"src":"/_next/static/media/select-arrow.6eb8300c.svg","height":105,"width":188,"blurWidth":0,"blurHeight":0};